import React from "react"

const ContactForm = props => (
<div className="landingSection contactSection">
  <div className="sectionHeader">
    <h1 className="sectionTitle">Contact Us</h1>
    <p className="sectionSubtitle">There is so much CueHit can offer your agency today. Reach out for a demonstration or discussion today.</p>
  </div>

  <form className="contactForm" action={"/contact-success"}>
    <div className="formRow">
      <label className="formInput">
        Name
        <input type="text" name="name" id="name" className="inputValue" placeholder="Phil Doe" />
      </label>

      <label className="formInput">
        Organization
        <input type="text" name="organization" id="organization" className="inputValue" placeholder="Everytown 911" />
      </label>
    </div>

    <div className="formRow">
      <label className="formInput">
        Email
        <input type="email" name="email" id="email" className="inputValue" placeholder="phildoe@everytown.org" />
      </label>

      <label className="formInput">
        Phone Number
        <input type="text" name="phoneNumber" id="phoneNumber" className="inputValue" placeholder="(555) 555-5555" />
      </label>
    </div>

    <label className="formInput formInputMultiline">
      <p className="inputTitle">Message</p>
      <textarea name="message" id="message" rows="5" placeholder="Dear CueHit team, ..." />
    </label>

    <input type="submit" className="actionSubmitForm">
    {/*<div className="buttonTitle">Send Message</div>*/}
    </input>
  </form>
</div>
)

export default ContactForm